import React, { useEffect, useState } from 'react';
import { Box, Button, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Chip, IconButton, CircularProgress } from '@mui/material';
import { MoreVert } from '@mui/icons-material';
import { api } from '../../../services/api';
import CreateStockModal from '../../modales/caja/CreateStockModal';

const StockTab = ({
  eventoId,
  allTarifas,
  allStock,
  loadingStock,
  refetchStock,
  onSuccess,
  onError
}) => {
  const [openStockModal, setOpenStockModal] = useState(false);
  const [loadingCreateStock, setLoadingCreateStock] = useState(false);

  const handleCrearStock = async (data) => {
    setLoadingCreateStock(true);
    const response = await api.stock.createStock(eventoId, {
      idtarifa: data.idtarifa,
      detalle: data.detalle,
      ingresos: data.ingresos,
    });
    setLoadingCreateStock(false);

    if (response.status === "success") {
      setOpenStockModal(false);
      onSuccess("Stock agregado correctamente");
      refetchStock();
    } else {
      onError(response.message || "Error al crear el stock");
    }
  };

  const handleStockAction = (stockId) => {
    console.log('stock tarifa:', stockId);
  };

  if (loadingStock) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 2 }}>
        <Typography
          variant="h6"
          sx={{
            fontSize: "18px",
            fontWeight: "600",
            color: "#5656ff",
          }}
        >
          Stock del Evento ({allStock?.length || 0})
        </Typography>
        <Button
          variant="outlined"
          sx={{
            marginLeft: "0 !important",
            backgroundColor: "#5656FF",
            color: "white",
            padding: "5px 10px",
            borderRadius: "4px",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: window.innerWidth <= 576 ? "13px" : "14px",
          }}
          onClick={() => setOpenStockModal(true)}
        >
          Agregar Stock
        </Button>
      </Box>


      {allStock?.length === 0 ? (
        <Box sx={{
          textAlign: 'center',
          py: 4,
          border: '1px dashed #ccc',
          borderRadius: 2,
          backgroundColor: '#f9f9f9'
        }}>
          <Typography color="text.secondary">
            No hay stock creado para este evento
          </Typography>
        </Box>
      ) : (
        <TableContainer component={Paper} sx={{ boxShadow: 1 }}>
          <Table>
            <TableHead sx={{ backgroundColor: '#E6E6FF' }}>
              <TableRow sx={{ borderColor: "#E6E6FF", textAlign: "center" }}>
                <TableCell /* align="center" */ sx={{ fontSize: "14px", fontWeight: "600", color: "#0B0060", fontFamily: "Bricolage Grotesque", }}>
                  Tarifa
                </TableCell>
                <TableCell /* align="center" */ sx={{ fontSize: "14px", fontWeight: "600", color: "#0B0060", fontFamily: "Bricolage Grotesque", }}>
                  Precio
                </TableCell>
                <TableCell align="center" sx={{ fontSize: "14px", fontWeight: "600", color: "#0B0060", fontFamily: "Bricolage Grotesque", }}>
                  Stock total
                </TableCell>
                <TableCell align="center" sx={{ fontSize: "14px", fontWeight: "600", color: "#0B0060", fontFamily: "Bricolage Grotesque", }}>
                  Vendido
                </TableCell>
                <TableCell align="center" sx={{ fontSize: "14px", fontWeight: "600", color: "#0B0060", fontFamily: "Bricolage Grotesque", }}>
                  Disponible
                </TableCell>
                <TableCell /* align="center" */ sx={{ fontSize: "14px", fontWeight: "600", color: "#0B0060", fontFamily: "Bricolage Grotesque", }} />
              </TableRow>
            </TableHead>
            <TableBody>
              {allStock?.map((stock) => (
                <TableRow
                  hover
                  key={stock.idtarifa}
                >
                  <TableCell>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Box sx={{
                        width: 16,
                        height: 16,
                        borderRadius: 1,
                        marginRight: 1,
                        backgroundColor: (() => {
                          try {
                            const c = JSON.parse(stock.color);
                            return `rgba(${c.r},${c.g},${c.b},${c.a})`;
                          } catch {
                            return "#eee";
                          }
                        })(),
                      }} />
                      <Typography sx={{
                        fontSize: '14px',
                        fontWeight: 500
                      }}>
                        {stock.concepto}
                      </Typography>
                    </Box>
                  </TableCell>

                  <TableCell /* align="center" */>
                    <Typography sx={{ fontSize: '14px' }}>
                      ${stock.precio.toLocaleString('es-AR')}
                    </Typography>
                  </TableCell>

                  <TableCell align="center">
                    <Typography sx={{
                      fontSize: '14px',
                      color: '#2e7d32',
                      fontWeight: 500
                    }}>
                      {stock.total_ingresos}
                    </Typography>
                  </TableCell>

                  <TableCell align="center">
                    <Typography sx={{
                      fontSize: '14px',
                      color: stock.total_egresos > 0 ? '#d32f2f' : '#666'
                    }}>
                      {stock.total_egresos > 0 ? `${stock.total_egresos}` : '0'}
                    </Typography>
                  </TableCell>

                  <TableCell align="center">
                    <Chip
                      label={stock.disponible}
                      size="small"
                      sx={{
                        backgroundColor: stock.disponible <= 10 ? '#ffebee' : '#e8f5e8',
                        color: stock.disponible <= 10 ? '#c62828' : '#2e7d32',
                        fontWeight: 600,
                        minWidth: 50
                      }}
                    />
                  </TableCell>

                  <TableCell align="center">
                    <IconButton
                      size="small"
                      sx={{ color: '#5656ff' }}
                      onClick={() => handleStockAction(stock.idtarifa)}
                    >
                      <MoreVert fontSize="small" />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      <CreateStockModal
        open={openStockModal}
        onClose={() => setOpenStockModal(false)}
        onCrear={handleCrearStock}
        allTarifas={allTarifas}
        loading={loadingCreateStock}
      />
    </Box>
  );
};

export default StockTab;